import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { GuiaSalida } from '../types/guiaSalida.types';

interface GuiaSalidaStore {
  guias: GuiaSalida[];
  loading: boolean;
  setGuias: (guias: GuiaSalida[]) => void;
  setLoading: (loading: boolean) => void;
}

export const useGuiaSalidaStore = create<GuiaSalidaStore>()(
  devtools(
    (set) => ({
      guias: [],
      loading: false,
      setGuias: (guias) => set({ guias }),
      setLoading: (loading) => set({ loading }),
    }),
    { name: 'GuiaSalidaStore' }
  )
);
